import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store/store'

import logIn from "@/views/commons/LogIn";
import signUp from "@/views/commons/SignUp";
import userHome from "@/views/user/home";
import ideaList from "@/views/user/ideaList";
import userProfile from "@/views/user/profile";
import dashboard from "@/views/admin/dashboard";
import dashboardHome from "@/views/admin/dashboardHome";
import users from "@/views/admin/allUsers";
import myAccount from "@/views/admin/myProfile";
import settings from "@/views/admin/settings";


Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        { path: "/", component: logIn },
        { path: "/home", component: userHome, meta: { requiresAuth: true } },
        { path: "/signUp", component: signUp },
        { path: "/my-profile", component: userProfile, meta: { requiresAuth: true } },
        { path: "/idea-list", component: ideaList, meta: { requiresAuth: true } },
        {
            path: "/dashboard", component: dashboard, children: [

                { path: "", component: dashboardHome, meta: { requiresAuth: true, forAdmin: true } },
                { path: "/users-list", component: users, meta: { requiresAuth: true, forAdmin: true } },
                { path: "/myAccount", component: myAccount, meta: { requiresAuth: true, forAdmin: true } },
                { path: "/settings", component: settings, meta: { requiresAuth: true, forAdmin: true } },
            ], meta: { requiresAuth: true, forAdmin: true }
        },
    ]
})

router.beforeEach((to, from, next) => {


    const loggedIn = !!localStorage.getItem('token')

    const isAdmin = store.getters['auth/isAdmin']
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const requiresAdmin = to.matched.some(record => record.meta.forAdmin);

    // console.log(token)

    if (requiresAuth) {
        if (loggedIn) {
            if (!requiresAdmin && isAdmin) {
                next('/dashboard')
                return
            } else if (requiresAdmin && !isAdmin) {
                next('/home')
                return
            } else {
                next()
                return
            }
        }else next('/')
    }
    next()
});

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        store.commit("loading", true)
    }
    next()
});

router.afterEach((to, from) => {
    // Complete the animation of the route progress bar.
    store.commit("loading", false)
})


export default router;